/** @format */

import { SysConfig, SysConfigVo } from '@/api';

/**
 * 获取全局的 VITE_ENV_BASE_URL
 * 如果 VITE_ENV_BASE_URL .length >1说明是在域名后面的子目录里面访问平台页面，
 * 否则为域名根目录里面访问平台页面。
 * @return VITE_ENV_BASE_URL eg: '/ywjk/' | '/'
 */
export function getEnvBaseUrl(): string {
	const VITE_ENV_BASE_URL = window?.pData?.env?.VITE_ENV_BASE_URL || '/';
	return VITE_ENV_BASE_URL;
}

/**
 * 通过资源地址获取环境的资源地址，兼容域名后子目录。
 * @param url 资源地址
 * @return 环境的资源地址
 */
export function getEnvUrlByUrl(url: string): string {
	if (url.indexOf('http') === 0) {
		// http开始的地址
		return url;
	}
	const VITE_ENV_BASE_URL = getEnvBaseUrl();

	if (url.indexOf(VITE_ENV_BASE_URL) === 0) {
		// VITE_ENV_BASE_URL 开始的地址
		return url;
	}
	let hrefUrl = url;
	if (url.indexOf('/') === 0 || url === '') {
		// / 开始的地址
		if (VITE_ENV_BASE_URL.length > 1) {
			hrefUrl = VITE_ENV_BASE_URL.substring(0, VITE_ENV_BASE_URL.length - 1) + url;
		} else {
			hrefUrl = url;
		}
	} else {
		hrefUrl = VITE_ENV_BASE_URL + url;
	}

	return hrefUrl;
}

/**
 * 获取当前子系统别名。
 * 获取 location 的 pathname 的去除 VITE_ENV_BASE_URL 后的第一个单词，
 * 一般这个是子系统的别名，
 * 如果是undefined需要跳转到第一个子系统的首页。
 * eg: /firstword/2/3 return firstword
 * @param pathname location pathname
 * @return SubSystemAlias | undefined
 */
export function getSubSystemAliasFromLocationPathname(pathname: string): string | undefined {
	if (window.pData?.env?.curSystemAlias && window.pData.env.curSystemAlias !== 'powercommon') {
		return window.pData.env.curSystemAlias;
	}
	let tmpStr = pathname;
	const VITE_ENV_BASE_URL = getEnvBaseUrl();
	if (VITE_ENV_BASE_URL?.length > 1) {
		if (tmpStr.indexOf(VITE_ENV_BASE_URL) === 0) {
			tmpStr = pathname.substring(VITE_ENV_BASE_URL.length - 1);
		}
	}
	const arr = tmpStr.split('/');
	return arr[1];
}

/**
 * 获取 location 的 pathname 的去除 VITE_ENV_BASE_URL 后的第一个单词，
 * 一般这个是子系统的别名，
 * 如果是undefined需要跳转到第一个子系统的首页。
 * eg: /firstword/2/3 return firstword
 * @param pathname location pathname
 * @return SubSystemAlias | undefined
 */
export function getFirstWordFromLocationPathname(pathname: string): string | undefined {
	let tmpStr = pathname;
	const VITE_ENV_BASE_URL = getEnvBaseUrl();
	if (VITE_ENV_BASE_URL?.length > 1) {
		if (tmpStr.indexOf(VITE_ENV_BASE_URL) === 0) {
			tmpStr = pathname.substring(VITE_ENV_BASE_URL.length - 1);
		}
	}
	const arr = tmpStr.split('/');
	return arr[1];
}

/**
 * 通过 系统前端配置数据、 code 和 itemCode 获取配置项数据
 * @param frontEndConfig 系统前端配置数据
 * @param code 第一层 code
 * @param itemCode 第二层 code
 */
export function getFrontEndConfigItemByCodeAndItemCode(
	frontEndConfig: SysConfig[],
	code: string,
	itemCode: string,
): SysConfigVo | undefined {
	const codeItemArr = frontEndConfig.filter((item) => {
		return item.code === code;
	});
	const codeItem = (codeItemArr && codeItemArr[0]) || undefined;
	if (codeItem) {
		const codeItemArr2 = codeItem.sysConfigVos.filter((item) => {
			return item.itemCode === itemCode;
		});
		const codeItem2 = (codeItemArr2 && codeItemArr2[0]) || {};
		return codeItem2;
	} else {
		return;
	}
}

/**
 * 通过资源id获取要访问的资源地址
 * 可用于下载
 * @param id 资源id
 * @return 要访问的资源地址
 */
export function getFileUrlById(id: string): string {
	let str = '';
	if (id.includes('/power-front-base/')) {
		str = id;
	} else {
		str = `power-api/base/oss/file/download?id=${id}`;
	}
	str = getEnvUrlByUrl(str);
	return str;
}

/**
 * 通过资源id获取要访问的资源预览地址
 * 可用于图片预览
 * 1762660980747034626
 * @param id 资源id
 * @return 要访问的资源预览地址
 */
export function getFilePreviewUrlById(id: string): string {
	let str = '';
	if (id.includes('/power-front-base/')) {
		str = id;
	} else {
		str = `power-api/base/oss/file/preview?attachmentId=${id}`;
	}
	str = getEnvUrlByUrl(str);
	return str;
}

/**
 * 获取头部样式类型
 * 1: 子系统左上角折叠
 * 3: 子系统水平放置
 * 2: 水平放置 //已弃用 地质项目有用到这个值
 */
export function getHeaderType() {
	const styleconfig = window.pData.env?.styleconfig || {};
	const curSystemAlias = window.pData?.env?.curSystemAlias || '';
	const headerType = styleconfig[curSystemAlias]?.headerType || styleconfig.default?.headerType || '1';
	return headerType;
}
